import ReactDom from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
//home
import "./css/carousel.css";
import "./css/contact.css";
import "./css/course.css";
import "./css/footer.css";
import "./css/global.css";
import "./css/login.css";
import "./css/navbar.css";
import "./css/news.css";
import "./css/us.css";
import "./css/advice.css";
import "./css/politics.css";
import "./css/capacitacion.css";
//estudiante
import "./css/student/student-portal.css";
import "./css/teacher-portal-layout.css";
import "./css/student/academic-calendar.css";
import "./css/student/aula-virtual.css";
import "./css/student/course-aula-virtual.css";

import "./css/company/portal-doc.css";
import "./css/company/portal-admin.css";
import "./css/company/portal-emp.css";
import "./css/aula-common.css";
import "./css/admission.css";
import "./backoffice/backoffice.css";
const root = ReactDom.createRoot(document.getElementById("root"));

root.render(
	<AuthProvider>
		<App />
	</AuthProvider>,
);
